var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IconConfirmation(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "8"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M12.19 7.29a1 1 0 011.4 1.4L9.2 13.1a1 1 0 11-1.41-1.42l4.4-4.38z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M6.29 11.54a1 1 0 011.4-1.4l1.55 1.54a1 1 0 11-1.42 1.4L6.3 11.55z"
  }));
}

export default IconConfirmation;